// extracted by mini-css-extract-plugin
module.exports = {"footerMenu":"FooterMenu_footerMenu__3oWlo","active":"FooterMenu_active__3FcN0"};